<template>
  <div class="w-full px-6 py-4">
    <div class="flex space-x-4 mb-6">
      <o-field-group class="w-full md:w-1/2" :label="$t('general.supplier')">
        <select-field v-model="_product.supplier" :options="supplierOptions" :label="$t('general.supplier')" />
      </o-field-group>

      <o-field-group class="w-full md:w-1/2" :label="$t('components.product.edit.inventory.supplierCode')">
        <text-field v-model="_product.supplierCode" :label="$t('components.product.edit.inventory.supplierCode')" />
      </o-field-group>
    </div>

    <div class="flex space-x-4 mb-6">
      <o-field-group class="w-full md:w-1/2" :label="$t('components.product.edit.inventory.reorderLevel')" :info="$t('components.product.edit.inventory.reorderLevelInfo')">
        <number-field v-model="_product.inventoryReorder" :label="$t('components.product.edit.inventory.reorderLevel')" />
      </o-field-group>

      <o-field-group class="w-full md:w-1/2" :label="$t('components.product.edit.inventory.minimumOrderQuantity')" :info="$t('components.product.edit.inventory.minimumOrderQuantityInfo')">
        <number-field v-model="_product.inventoryMinimum" :label="$t('components.product.edit.inventory.minimumOrderQuantity')" />
      </o-field-group>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  OCustomFields,
} from '@/components/elements'

import {
  TextField,
  SelectField,
  NumberField,
} from '@/components/fields'

interface Props {
  product: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:product', value: any): void
}>()

const _product = computed({
  get () {
    return props.product
  },
  set (value: any) {
    emit('update:product', value)
  },
})

const supplierOptions = computed(() => {
  const suppliers = _product.value.options.suppliers || []

  return suppliers
    .map((supplier: any) => {
      return {
        label: supplier.name,
        value: supplier,
      }
    })
})
</script>
